import { useEffect, useState } from "react";
import Tester from "../Tester";

export default function useTester(){

    const [tester, setTester] = useState(null)

    useEffect(() => {

        setTester(Tester);

    }, [])

    return tester;
}
